export const changeendDateReducer = (state = null, action) => {
    switch (action.type) {
      case "CHANGE_END_DATE":
        return action.payload.endDate;
      default:
        return state;
    }
  };
  